import { Box, Button, Typography } from "@mui/material";
import { useEffect } from "react";
import { Link } from "react-router-dom";

const AppRedirect = ({ children }) => {
  useEffect(() => {
    window.location.href = "https://app.umlang.com/";
  }, []);
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: "#3f4652",
      }}
    >
      <Button variant="contained">
        <Link
          to="https://app.umlang.com/"
          style={{ textDecoration: "none", color: "white" }}
        >
          دریافت آخرین نسخه
        </Link>
      </Button>
    </Box>
  );
};

export default AppRedirect;
